import { SVGProps } from 'react';
const SvgMenuAlt01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 17h7M5 12h14M5 7h14"
    />
  </svg>
);
export default SvgMenuAlt01;
